import React from "react";
import { FieldGroup } from "../../components";
import { DataHelper } from "../../helpers";
import { Window } from "../../contexts";
import { useFormikContext } from "formik";
import useCategories from "../../hooks/useCategories.js";

const BusinessMerchant = ({ user, isProfile, isRC }) => {
  const { setFieldValue } = useFormikContext();
  const isCreateForm = !user && !isProfile;
  const categoryOptions = useCategories();

  const onStoreChange = (data) => {
    if (data) {
      setFieldValue("store_url", data.store_url || "");
      setFieldValue("shopify_url", data.store_url || "");
    }
  };

  if (isCreateForm) {
    return (
      <div className="business-form business-form--merchant business-form--create">
        {/* Contact owner sits in the Overview head on create. */}
        <div className="row overview-form__row">
          <div className="col-md-6">
            <FieldGroup
              bare
              placeholder="Dealer"
              type="select"
              name="dealer"
              options={DataHelper.dealers}
              disabled={isRC}
            />
          </div>
        </div>

        <div className="row overview-form__row">
          <div className="col-md-6">
            {!isRC && (
              <FieldGroup
                bare
                placeholder="Store"
                name="store_id"
                type="storeSelect"
                disabled={isProfile}
                onChange={(data) => onStoreChange(data)}
              />
            )}
            {isRC && <FieldGroup bare placeholder="Store" name="store_id" />}
            <FieldGroup bare placeholder="Job Title" name="title" />
            <FieldGroup
              bare
              placeholder="Environment"
              type="select"
              name="work_environment"
              options={DataHelper.environments}
              disabled={isRC}
            />
          </div>

          <div className="col-md-6">
            <FieldGroup bare placeholder="Store Url" name="store_url" />
            <FieldGroup bare placeholder="Company" name="company" disabled={isRC} />
            <FieldGroup
              bare
              placeholder="Shopify Url"
              name="shopify_url"
              disabled={isRC}
            />
          </div>
        </div>

        {!isRC && (
          <div className="business-form__expertise">
            <FieldGroup
              bare
              label="Work expertise"
              name="expert_categories"
              type="multiselect"
              maxSelections={2}
              options={categoryOptions}
              disabled={isRC}
              className="business-form__expertise-field rc-create-multiselect"
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="business-form business-form--merchant">
      <div className="row">
        {!isProfile && !user?.is_sales_admin && (
          <div className="col-md-6 pr-16">
            <FieldGroup
              placeholder="Contact owner"
              type="select"
              name="owner_id"
              optionsUrl={`/api/users/sales-admins`}
              optionsMethod="post"
              disabled={isRC}
            />
          </div>
        )}
        <div className="col-md-6 pr-16">
          <FieldGroup
            placeholder="Dealer"
            type="select"
            name="dealer"
            options={DataHelper.dealers}
            disabled={isRC}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 pr-16">
          {!isRC && (
            <FieldGroup
              placeholder="Store"
              name="store_id"
              type="storeSelect"
              disabled={isProfile}
              onChange={(data) => onStoreChange(data)}
            />
          )}
          {isRC && <FieldGroup placeholder="Store" name="store_id" />}

          <FieldGroup placeholder="Job Title" name="title" />
          <FieldGroup
            placeholder="Environment"
            type="select"
            name="work_environment"
            options={DataHelper.environments}
            disabled={isRC}
          />
        </div>

        <div className="col-md-6">
          <FieldGroup placeholder="Store Url" name="store_url" />
          <FieldGroup placeholder="Company" name="company" disabled={isRC} />
          <FieldGroup
            placeholder="Shopify Url"
            name="shopify_url"
            disabled={isRC}
          />
        </div>
      </div>
      {!isRC && (
        <div className="business-form__expertise">
          <FieldGroup
            label="Work expertise"
            name="expert_categories"
            type="multiselect"
            maxSelections={2}
            options={Window.CATEGORIES}
            disabled={isRC}
          />
        </div>
      )}
    </div>
  );
};

export default BusinessMerchant;
